import "./EndImage.scss";
import {
  ImageTooltips,
  ImageTooltipsItem,
  ImageTooltipsTrigger,
} from "react-image-tooltips";
import "react-image-tooltips/dist/index.css";

function EndImage() {
  const MyTrigger = (
    <ImageTooltipsTrigger className="my-trigger">+</ImageTooltipsTrigger>
  );

  return (
    <div className="App">
      <ImageTooltips
        src="/end.png"
        width={1000}
        height={900}
        className="my-image"
        triggerEvent="click"
      >
        <ImageTooltipsItem
          top={352}
          left={448}
          trigger={MyTrigger}
          className="my-item"
        >
          <p>Bolus Button</p>
        </ImageTooltipsItem>
        <ImageTooltipsItem
          top={374}
          left={523}
          trigger={MyTrigger}
          className="my-item"
        >
          <p>Start/Stop Button</p>
          <p>This button is used to start/stop the perfuser pump</p>
        </ImageTooltipsItem>
      </ImageTooltips>
    </div>
  );
}

export default EndImage;
